(() => {
  angular
    .module('gm.common.currency')
    .directive('gmyCurrencyFlag', gmyCurrencyFlag);

  function gmyCurrencyFlag(
    GmyCurrencies
  ) {
    'ngInject';

    return {
      link,
      restrict: 'A',
      scope: {
        gmyCurrencyFlag: '='
      },
    };

    function link(scope, element) {
      const currencies = GmyCurrencies.getCurrencyHash();
      let lastClass = null;

      function onCurrencyFlagChange(currencyCode) {
        if (lastClass) {
          element.removeClass(lastClass);
          lastClass = null;
        }

        if (currencyCode) {
          const currency = currencies[currencyCode];

          if (currency) {
            element.addClass(currency.flag);
            lastClass = currency.flag;
          }
        }
      }

      scope.$watch('gmyCurrencyFlag', onCurrencyFlagChange);
    }
  }
})();
